/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import qs from 'query-string'
import AppstoreLayout from 'components/organisms/AppstoreLayout'
import { bindStateToProps, bindActionCreators } from 'lib'

class AppstorLayoutContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    const search = window.location.search
    const { categories, appName } = qs.parse(search.replace(/^\?/, ''), {
      arrayFormat: 'bracket'
    })
    this.state = { categories, appName }
  }

  onKeyPressSearchField(e) {
    const keyCode = e.keyCode || e.which
    if (Number(keyCode) !== 13) return
    const { categories } = this.state
    const appName = e.target.value
    this.searchAppList({ appName, categories })
  }

  onChangeCategories(e) {
    const { categories, appName } = this.state
    const value = e.target.value
    if (value.indexOf('') !== -1) {
      if (categories && categories.indexOf('') === -1) {
        return this.searchAppList({ appName, categories: [''] })
      }
      return this.searchAppList({ appName, categories: value.filter(d => d) })
    }
    return this.searchAppList({ appName, categories: value })
  }

  searchAppList(params = {}) {
    if (params.categories && params.categories.filter(d => d).length) {
      Object.assign(params, { categories: params.categories })
    }
    const searchParams = Object.assign(
      {},
      ...Object.keys(params)
        .filter(key => {
          return !!params[key]
        })
        .map(key => ({ [key]: params[key] }))
    )
    const query = qs.stringify(searchParams, { arrayFormat: 'bracket' })
    window.location.href = `/apps${query ? `?${query}` : ''}`
  }

  render() {
    const props = Object.assign({}, this.props, this.state)
    return <AppstoreLayout proxy={this} {...props} />
  }
}

export default connect(
  bindStateToProps({ appstore: 'appListLoading' }),
  bindActionCreators({})
)(AppstorLayoutContainer)
